import React from 'react';
import PropTypes from 'prop-types';

import { FormattedMessage } from 'react-intl';
import Icon from '../../components/Icon';
import Button from '../../components/Button';
import Loader from '../../components/Loader';
import Dimmer from '../../components/Dimmer';
import Header from '../../components/Header';
import Modal from '../../components/Modal';

class ManageUsersModal extends React.PureComponent {
  static propTypes = {
    user: PropTypes.object,
    changing: PropTypes.bool,
    confirmOpen: PropTypes.bool,
    confirmMessage: PropTypes.string,
    header: PropTypes.string,
    onCancel: PropTypes.func,
    onConfirm: PropTypes.func,
    id: PropTypes.string,
    errorDetails: PropTypes.string,
  };

  constructor(props) {
    super(props);
    this.state = {
      confirmOpen: this.props.confirmOpen,
    };
  }

  componentWillReceiveProps(nextProps) {
    if (this.state.confirmOpen !== nextProps.confirmOpen) {
      this.setState({ confirmOpen: nextProps.confirmOpen });
    }
  }

  render() {
    const { header, changing, confirmMessage, onCancel, onConfirm, id, errorDetails } = this.props;
    const { confirmOpen } = this.state;
    return (
      <Dimmer.Dimmable role="dialog" aria-label={header} as={Modal} open={confirmOpen} id={id} onClose={onCancel}>
        <Dimmer
          tabIndex={-1}
          role="progressbar"
          aria-label="Loading"
          aria-busy={changing}
          inverted
          active={changing}
        >
          <Loader active={changing} />
        </Dimmer>
        <Header as="h2">
          {header}
        </Header>
        <Modal.Content>
          <p>
            {confirmMessage}
          </p>
          {errorDetails}
        </Modal.Content>
        <Modal.Actions>
          <Button icon labelPosition="left" negative onClick={onCancel} data-cy="manage-users-modal-negative-button">
            <Icon name="remove" />
            <FormattedMessage id="common.button.no" defaultMessage="No" />
          </Button>
          <Button icon labelPosition="left" positive onClick={onConfirm} data-cy="manage-users-modal-positive-button">
            <Icon name="checkmark" />
            <FormattedMessage id="common.button.yes" defaultMessage="Yes" />
          </Button>
        </Modal.Actions>
      </Dimmer.Dimmable>
    );
  }
}

export default ManageUsersModal;
